import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import {globalfunc} from '../globalfunc.js'
import { getCompany,getTeamByCompany,getUserAll } from './core/cacheService'
import axios from 'axios';
export default {
    namespaced: true,
    state: {
        membersall: [],
        membersByTeam: [],
        membersByCohort: [],
        membersByHouse: [],
        cohorts:[],
        cohortsall:[],
        inputSearch: '',
        page:1,
        size_page:10,
        results: 0,
        sortBy: 'name',
        cohortsDuplicate: [],
        organizations: [],
        loadingCohortsTable: true,
        house:{
            1:'-LWPrZbcyHAVHIFUsWLd', //Corvus
            2:'-LWOr-XsbZM2digYl1QL', //Delphinus
            3:'-LWPrOElCYViBd6j6qP-', //Leonos
        },
        cohortRandomNumber: '',
        dynamicCohortMembers: [],
    },
    mutations: {
        setCohorts(state:any, result:any) {
            state.cohorts = result
        },
        setCohortsAll(state:any, result:any) {
            state.cohortsall = result
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.value
        },
        setPage(state:any,result:any) {
            state.page = result
        },
        setResults(state:any, result:any) {
            state.results = result
        },
        setCohortsDuplicate(state:any, result:any) {
            state.cohortsDuplicate = result
        },
        setLoadingCohortsTable(state:any, result:any) {
            state.loadingCohortsTable = result
        },
        setMembersByTeam(state:any, result:any) {
            state.membersByTeam = result
        },
        setMemberall(state:any, result:any) {
            state.membersall = result
        },
        setMemberByCohort(state:any, result:any) {
            state.membersByCohort = result
        },
        setMemberByHouse(state:any, result:any) {
            state.membersByHouse = result
        },
        setCohortRandomNumber(state: any, value: any) {
            state.cohortRandomNumber = value
        },
        setDynamicCohortMembers(state:any, result:any) {
            state.dynamicCohortMembers = result
        },
    },
    actions: {
        async generateCohortRandomNumber({commit,dispatch,state,rootState}:any, cohorts:any){
            let num = 'c'+globalfunc.generateRandomNumber()
            if(!cohorts) cohorts = (await firebase.database().ref(`/cohorts`).once('value')).val();
            let duplicate = false;
            for(const comId in cohorts){
              for(const x in cohorts[comId]){
                if(cohorts[comId][x].internal_id == num){
                  duplicate = true;
                  break;
                }
              }
              if(duplicate) break;
            }
            if(duplicate){
              num = await dispatch('generateCohortRandomNumber',cohorts)
            }
            commit('setCohortRandomNumber', num)
        },
        async getCohorts({commit,dispatch,state,rootState}:any, payload:any){
            const params = (payload && payload.user) ? payload : { user: payload };
            const user = params.user;
            const keepPage = !!params.keepPage;
            let requestedPage = params.page || (keepPage ? state.page : 1);
            if (!requestedPage || requestedPage < 1) {
                requestedPage = 1;
            }
            commit('setLoadingCohortsTable',true)
            commit('setCohorts',[])
            let dateNow = new Date()
            const checkCohorts:Array<any> = []
            let cohorts_duplicate:Array<any> = []
            cohorts_duplicate['status'] = false
            cohorts_duplicate['count'] = 0
            let userData:Array<any> = [];
            let membersByCohort:Array<any> = [];
            let membersByTeam:Array<any> = [];
            let membersByHouse:Array<any> = [];
            let noDup = 0
            const company = await getCompany(user.company)
            const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            // Prefer already-cached users in main module when available
            if (rootState && rootState.main && rootState.main.allUser && Object.keys(rootState.main.allUser).length > 0) {
                for(const arrData in rootState.main.allUser){
                    const u = rootState.main.allUser[arrData]
                    u.key = arrData
                    if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
                    if(u.profilepic_small){
                        u.pic = u.profilepic_small;
                    }else if (u.profilepic_crop){
                        u.pic = u.profilepic_crop;
                    }else if (u.profilepic){
                        u.pic = u.profilepic;
                    }else {
                        u.pic = "";
                    }
                    if(u.tutorial && u.tutorial == 'Y'){
                        let dayActive = differenceInCalendarDays(dateNow, u.updated)
                        if(dayActive > 30){
                            u.status = 'inactive'
                            u.to_now = format(u.updated,'MMM D, YYYY')
                        }else{
                            u.status = 'active'
                            u.to_now = globalfunc.timeSince(u.updated)
                        }
                    }else if(u.invited){
                        u.status = 'invited'
                        u.to_now = globalfunc.timeSince(u.updated)
                    }else{
                        u.status = 'new'
                    }
                    userData[u.email] = u
                    if(membersByTeam[u.team] === undefined){
                        membersByTeam[u.team] = new Array()
                    }
                    membersByTeam[u.team].push(u)
                }
            } else {
                // Fallback: fetch users for company via the BFF if cache is not ready
                // (no whole-node RTDB query). Clone each record — the BFF map is a
                // shared cache object and this block decorates it (pic/status/...).
                const allUser = await getUserAll(user.company)//firebase.database().ref().child('users').orderByChild('company').equalTo(`${user.company}`).once('value')
                Object.entries(allUser || {}).forEach(([memberKey, member]: [string, any]): any => {
                    const u = { ...member }
                    u.key = memberKey
                    if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
                    if(u.profilepic_small){
                        u.pic = u.profilepic_small;
                    }else if (u.profilepic_crop){
                        u.pic = u.profilepic_crop;
                    }else if (u.profilepic){
                        u.pic = u.profilepic;
                    }else {
                        u.pic = "";
                    }
                    if(u.tutorial && u.tutorial == 'Y'){
                        let dayActive = differenceInCalendarDays(dateNow, u.updated)
                        if(dayActive > 30){
                            u.status = 'inactive'
                            u.to_now = format(u.updated,'MMM D, YYYY')
                        }else{
                            u.status = 'active'
                            u.to_now = globalfunc.timeSince(u.updated)
                        }
                    }else if(u.invited){
                        u.status = 'invited'
                        u.to_now = globalfunc.timeSince(u.updated)
                    }else{
                        u.status = 'new'
                    }
                    userData[u.email] = u
                    if(membersByTeam[u.team] === undefined){
                        membersByTeam[u.team] = new Array()
                    }
                    membersByTeam[u.team].push(u)
                });
            }


            // await firebase.database().ref().child('users').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
            //     snapshot.forEach((arrData):any => {
            //         const u = arrData.val()
            //         u.key = arrData.key
            //         if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
            //         if(u.profilepic_small){
            //             u.pic = u.profilepic_small;
            //           }else if (u.profilepic_crop){
            //             u.pic = u.profilepic_crop;
            //           }else if (u.profilepic){
            //             u.pic = u.profilepic;
            //           }else {
            //             u.pic = "";
            //           }
            //         if(u.tutorial && u.tutorial == 'Y'){
            //         let dayActive = differenceInCalendarDays(dateNow, u.updated)
            //         if(dayActive > 30){
            //             u.status = 'inactive'
            //             u.to_now = format(u.updated,'MMM D, YYYY')
            //         }else{
            //             u.status = 'active'
            //             u.to_now = globalfunc.timeSince(u.updated)
            //         }
            //         }else if(u.invited){
            //             u.status = 'invited'
            //             u.to_now = globalfunc.timeSince(u.updated)
            //         }else{
            //             u.status = 'new'
            //         }
            //         userData[u.email] = u
            //         if(membersByTeam[u.team] === undefined){
            //             membersByTeam[u.team] = new Array()
            //         }
            //         membersByTeam[u.team].push(u)
            //     });
            // });
            _.forEach(state.house, (houseId, index) => {
                firebase.firestore().collection(`houses/${user.company}${houseId}/members`).orderBy('firstname').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        const _data = doc.data()
                        _data.key = doc.id
                        if(userData[_data.email]){
                            if(membersByHouse[houseId] === undefined){
                                membersByHouse[houseId] = new Array()
                            }
                            membersByHouse[houseId].push(_data)
                        }
                    });
                });
            });
            
            firebase.database().ref(`cohorts/${user.company}`).once('value',async snapshot => {
                const cohorts:Array<any> = [];
                snapshot.forEach((doc):any => {
                    const c = doc.val()
                    c.key = doc.key
                    c.users = c.users || {}
                    c.value = doc.val().name
                    c.company_name = company.name
                    if(c.sup === undefined){
                        c.sup = new Array()
                    }
                    if(c.name){
                        if(checkCohorts[c.name.toLowerCase()]){
                            cohorts_duplicate['status'] = true
                            cohorts_duplicate['count'] += 2
                            c.duplicate = true
                            c.duporder = noDup
                            noDup++
                            const cohortKey = _.findKey(cohorts, ['name', checkCohorts[c.name.toLowerCase()]])
                            if(cohortKey){
                                cohorts[cohortKey].duplicate = true
                                cohorts[cohortKey].duporder = noDup
                                noDup++
                            }
                        }
                        checkCohorts[c.name.toLowerCase()] = c.name
                    }
                    if(c.users){
                        for (const x in c.users) {
                            if(userData[c.users[x]]){
                                c.sup = _.concat(c.sup, userData[c.users[x]]);
                            }
                        }
                        // Dedupe by email — c.users can contain the same key
                        // more than once when upstream data has duplicate user
                        // records sharing an email.
                        c.sup = _.uniqBy(_.compact(c.sup), 'email')
                        c.sup = _.sortBy(c.sup, [function(o:any) { return o.firstname; }])
                    }
                    membersByCohort[c.key] = c.users
                    // TODO (Backend): Load rules from c.rules when backend provides it
                    // For now, rules will be null/undefined if not present
                    c.rules = c.rules || null;
                    cohorts.push(c)
                });
                var _cohorts = _.sortBy(cohorts, [function(o:any) { return o.duporder; }, function(o:any) { return o.name; }])
                commit('setResults',_cohorts)
                commit('setCohortsDuplicate',cohorts_duplicate)
                commit('setCohortsAll', _cohorts)
                const totalPages = Math.max(1, Math.ceil(_cohorts.length / state.size_page));
                const safePage = Math.min(Math.max(1, requestedPage), totalPages);
                const startIndex = (safePage - 1) * state.size_page;
                const endIndex = startIndex + state.size_page;
                commit('setPage', safePage)
                commit('setCohorts', _cohorts.slice(startIndex, endIndex))
                commit('setLoadingCohortsTable',false)
                commit('setMembersByTeam', membersByTeam)
                commit('setMemberall',userData)
                commit('setMemberByCohort',membersByCohort)
                commit('setMemberByHouse',membersByHouse)
                if(state.inputSearch){
                    dispatch('searchCohorts',state.inputSearch)
                }
            }).catch(error => {
                console.log(error)
            });
        },
        async updateCohort({commit,rootState,dispatch,state}:any,form:any){
            const nowDate = format(new Date(), 'YYYY-MM-DD HH:mm')
            const member = {};
            if(form.leaderMember.length > 0){
                _.forEach(form.leaderMember, (item, index) => {
                    member[item.key] = item.email
                });
            }
            const updateData:any = {
                name:form.cohort_name,
                color:(form.color)?form.color:'',
                leaders: (Object.keys(member).length > 0) ? member : null,
                updated:nowDate
            };
            // TODO (Backend): Persist rules JSON for dynamic cohorts
            // Include rules if it's a dynamic cohort (type === 'auto')
            const isDynamicCohort = form.type === 'auto' && !_.isEmpty(form.rules);
            if(isDynamicCohort){
                updateData.rules = form.rules;
                updateData.type = 'auto'; // Ensure type is set
            }
            firebase.database().ref(`/cohorts/${rootState.authen.user.company}/${form.id}`).update(updateData).then(async ()=>{
                if(Object.keys(form.newMemberAdd).length > 0){
                    firebase.database().ref(`cohorts/${rootState.authen.user.company}/${form.id}/users`).update(
                        form.newMemberAdd
                    )
                }
                if(isDynamicCohort){
                    // Trigger to get dynamic cohort members
                    await dispatch('getDynamicCohortMembers', { id: form.id, table: 'cohorts' });
                }
            }).then(()=>{
                dispatch('getCohorts',{ user: rootState.authen.user, keepPage: true })
            });
        },
        async createCohorts({commit,rootState,dispatch,state}:any,form:any){
            const newId = firebase.database().ref(`cohorts/${rootState.authen.user.company}`).push().key;
            const nowDate = format(new Date(), 'YYYY-MM-DD HH:mm')
            const member = {};
            if(form.leaderMember.length > 0){
                _.forEach(form.leaderMember, (item, index) => {
                    member[item.key] = item.email
                });
            }
            const createData:any = {
                name:form.cohort_name,
                color:(form.color)?form.color:'',
                created:nowDate,
                updated:nowDate,
                internal_id: form.internal_id,
                users: (Object.keys(form.newMemberAdd).length > 0) ? form.newMemberAdd : null,
                leaders: (Object.keys(member).length > 0) ? member : null,
            };
            // TODO (Backend): Persist rules JSON for dynamic cohorts
            // Include rules if it's a dynamic cohort (type === 'auto')
            const isDynamicCohort = form.type === 'auto' && !_.isEmpty(form.rules);
            if (isDynamicCohort) {
                createData.rules = form.rules;
                createData.type = 'auto'; // Ensure type is set

                // Add leaders to the createData for Dynamic Cohort (auto) because it's no members in the cohort
                if(form.leaderMember.length > 0){
                    _.forEach(form.leaderMember, (item, index) => {
                        _.set(createData, 'leaders.' + item.key, item.email);
                    });
                }
            }
            firebase.database().ref(`cohorts/${rootState.authen.user.company}/${newId}`).update(createData).then(async ()=>{
                if (isDynamicCohort) {
                    // Trigger to get dynamic cohort members
                    await dispatch('getDynamicCohortMembers', { id: newId, table: 'cohorts' });
                }
                firebase.database().ref(`/calculate_cohort`).push({
                    cohort:newId,
                    company:rootState.authen.user.company
                });
                dispatch('getCohorts',rootState.authen.user)
            });
        },
        async getDynamicCohortMembers({commit,rootState,dispatch,state}:any, {id, table = 'cohorts'}: any){
            const company = rootState.authen.user.company;
            // const table = 'cohorts';
            const url = `https://api-node.happily.ai/cohort/evaluate/${table}/${company}/${id}`;
            try {
                const response = await axios.get(url);
                const members = _.get(response, 'data.matchedUsers', []);
                commit('setDynamicCohortMembers', members);
            } catch (error) {
                console.log(error);
                commit('setDynamicCohortMembers', []);
            }
        },
        async previewDynamicCohort({commit,rootState,dispatch,state}:any,modalForm:any){
            const form = _.cloneDeep(modalForm);
            form.type = 'auto';

            const table = 'cohorts_preview';

            // @see createCohorts
            // TODO: use common fucnction to create this data object same as createCohorts
            const newId = firebase.database().ref(`${table}/${rootState.authen.user.company}`).push().key;
            const nowDate = format(new Date(), 'YYYY-MM-DD HH:mm')
            const member = {};
            if(form.leaderMember.length > 0){
                _.forEach(form.leaderMember, (item, index) => {
                    member[item.key] = item.email
                });
            }
            const createData:any = {
                name:form.cohort_name,
                color:(form.color)?form.color:'',
                created:nowDate,
                updated:nowDate,
                internal_id: form.internal_id,
                users: (Object.keys(form.newMemberAdd).length > 0) ? form.newMemberAdd : null,
                leaders: (Object.keys(member).length > 0) ? member : null,
            };

            const isDynamicCohort = form.type === 'auto' && !_.isEmpty(form.rules);
            if (isDynamicCohort) {
                createData.rules = form.rules;
                createData.type = 'auto'; // Ensure type is set

                // Add leaders to the createData for Dynamic Cohort (auto) because it's no members in the cohort
                if(form.leaderMember.length > 0){
                    _.forEach(form.leaderMember, (item, index) => {
                        _.set(createData, 'leaders.' + item.key, item.email);
                    });
                }
            }

            await firebase.database().ref(`${table}/${rootState.authen.user.company}/${newId}`).update(createData).then(async ()=>{
                await dispatch('getDynamicCohortMembers', { id: newId, table });
                await firebase.database().ref(`${table}/${rootState.authen.user.company}/${newId}`).remove();
            }).catch((error)=>{
                console.log(error);
            });
        },
        deleteCohort({commit,rootState,dispatch}:any,key:any){
            firebase.database().ref(`/cohorts/${rootState.authen.user.company}/${key}`).remove().then(()=>{
                firebase.database().ref(`/delete_cohort`).push({
                    cohort:key,
                });
                dispatch('getCohorts',rootState.authen.user) 
            });
        },
        removeUserCohort({commit,rootState,dispatch}:any,obj:any){
            firebase.database().ref(`/cohorts/${rootState.authen.user.company}/${obj.id}/users/${obj.userKey}`).remove().then(()=>{
                dispatch('getCohorts',rootState.authen.user)
            });
        },
        currentChange({commit,state}:any,page:any){
            var size = state.size_page
            var start_row = (page-1) * size
            var end_row = ((page-1) * size)+size
            let cohorts: Array<any> = [];
            
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                var response = _.filter(state.cohortsall, (item):any => {
                    if (item && item.name && item.name.match(re)){
                        return true
                    } else if (item && item.description && item.description.match(re)) {
                        return true;
                    }
                });
                cohorts = response
            }else{
                cohorts = state.cohortsall
            }

            if (state.sortBy == 'name') {
                cohorts = _.sortBy(cohorts, [function(o:any) { return o.name; }])
            }
            let result = cohorts.slice(start_row,end_row)
            commit('setPage',page)
            commit('setResults', cohorts)
            commit('setCohorts', result)
        },
        searchCohorts({commit,state}:any,value:string){
            commit('setPage',1)
            let response: Array<any> = [];
            var re = new RegExp(value, 'gi')
            response = _.filter(state.cohortsall, (item):any => {
                if (item && item.name && item.name.match(re)){
                    return true
                } else if (item && item.description && item.description.match(re)) {
                    return true;
                }
            });
            if (state.sortBy == 'name') {
                response = _.sortBy(response, [function(o:any) { return o.duporder; },function(o:any) { return o.name; }])
            }
            commit('setResults', response)
            commit('setCohorts',response.slice(0,state.size_page))
        },
        sortBy({ commit, state }: any, type: string) {
            commit('setPage',1)
            state.sortBy = type
            let cohorts: Array<any> = [];
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                var response = _.filter(state.cohortsall, (item):any => {
                    if (item && item.name && item.name.match(re)){
                        return true
                    } else if (item && item.description && item.description.match(re)) {
                        return true;
                    }
                });
                cohorts = response
            }else{
                cohorts = state.cohortsall
            }
            if (type == 'name') {
                cohorts = _.sortBy(cohorts, [function(o:any) { return o.duporder; },function(o:any) { return o.name; }])
            }
            commit('setCohorts',cohorts.slice(0,state.size_page))
        },
    },
    getters: {
        membersall: (state:any) => {
            return state.membersall
        },
        membersByTeam: (state:any) => {
            return state.membersByTeam
        },
        membersByCohort: (state:any) => {
            return state.membersByCohort
        },
        membersByHouse: (state:any) => {
            return state.membersByHouse
        },
        cohortsall: (state:any) => {
            return state.cohortsall
        },
        cohorts : (state:any) => {
            return state.cohorts
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        results : (state:any) => {
            return state.results
        },
        page : (state:any) => {
            return state.page
        },
        cohortsDuplicate : (state:any) => {
            return state.cohortsDuplicate
        },
        loadingCohortsTable : (state:any) => {
            return state.loadingCohortsTable
        },
        cohortRandomNumber : (state:any) => {
            return state.cohortRandomNumber
        },
        dynamicCohortMembers : (state:any) => {
            return state.dynamicCohortMembers
        },
    }
  }
